const initialState = {
  ref: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_REF":
      return {
        ...state,
        ref: action.payload,
      };

    default:
      return state;
  }
}
